import { MSConstant } from '@/commons/wildcards/index.js';
import store from '@/stores/store';
import { ModuleDbOption } from '@/stores/moduleConst';
const state = {
  superiorSourceSelected: [], // Những nguồn kinh phí cấp trên
  dataStepOne: {
    // Dữ liệu bước 1
    gridInfoReportSelected: [], // Các báo cáo được chọn ở bước 1
    period: 101, // Quý này
    periodText: 'Quý I', // Kỳ báo cáo - Text
    year: new Date().getFullYear(), //Năm
    yearText: '',
    isCheckBoxForStepOne: false, //Checkbox "Bao gồm số liệu..."
    isFundIncludedSalaryReformAmount: false, // checkbox Số kinh phí sử dụng bao gồm số trích lập Cải cách tiên lương
    postedYear: new Date().getFullYear(),
    isCheckBoxRealityAriseForStepOne: false, //Checkbox "Số dự toán năm lấy theo thực tết phát sinh"
  },
  dataStepThree: {
    financialGridData: [],
    settlementGridData: [],
  },
};

const getters = {
  /**
   * Lấy dữ liệu nguồn kinh phí cấp trên
   */
  superiorSourceSelected(state) {
    return state.superiorSourceSelected;
  },
};

const actions = {};

const mutations = {
  /**
   *
   * @param {*} state
   * Xóa dữ liệu
   */
  clearData(state) {
    let postedDate = store.getters['context/PostedDate'];
    let dbOptions = store.state[ModuleDbOption]?.dbOptions;

    var dataStepOne = {
      gridInfoReportSelected: [],
      year: new Date().getFullYear(),
      isCheckBoxForStepOne: false,
    };
    state.dataStepOne = dataStepOne;

    state.superiorSourceSelected = [];

    var period = {
      period: MSConstant.ReportPeriod.QuarterI,
      periodText: 'Quý I',
    };

    let quarter = Math.floor(new Date().getMonth() / 3) + 1;
    switch (quarter) {
      case 1: {
        period.period = MSConstant.ReportPeriod.QuarterI;
        period.periodText = 'Quý I';
        break;
      }
      case 2: {
        period.period = MSConstant.ReportPeriod.QuarterII;
        period.periodText = 'Quý II';
        break;
      }
      case 3: {
        period.period = MSConstant.ReportPeriod.QuarterIII;
        period.periodText = 'Quý III';
        break;
      }
      case 4: {
        period.period = MSConstant.ReportPeriod.QuarterIV;
        period.periodText = 'Quý IV';
        break;
      }
    }
    state.dataStepOne.period = period.period;
    state.dataStepOne.periodText = period.periodText;

    if (dbOptions?.DBStartDate) {
      state.dataStepOne.postedYear = dbOptions?.DBStartDate.getFullYear();
    }

    if (postedDate) {
      state.dataStepOne.year = postedDate.getFullYear();
      state.dataStepOne.yearText = postedDate.getFullYear().toString();
    }
  },

  /**
   * Cập những báo cáo cần nộp lên
   * @param {*} state
   * @param {*} data
   */
  updateGridInfoReportSelected(state, data) {
    state.dataStepOne.gridInfoReportSelected = data;
  },

  /**
   * Cập nhật năm
   * @param {*} state
   * @param {*} data
   */
  updateYear(state, data) {
    state.dataStepOne.year = data;
    state.dataStepOne.yearText = data.toString();
  },

  /**
   * Cập nhật kỳ báo cáo
   * @param {*} state
   * @param {*} data
   */
  updatePeriod(state, data) {
    state.dataStepOne.period = data.enumValue;
    state.dataStepOne.periodText = data.enumText;
  },

  /**
   * Cập nhật dữ liệu checkBox Bao gồm số liệu SXKD
   * @param {*} state
   * @param {*} data
   */
  updateIsCheckBoxForStepOne(state, data) {
    state.dataStepOne.isCheckBoxForStepOne = data;
  },
  /**
   * Cập nhật nguồn kinh phí cấp trên
   * @param {*} state
   * @param {*} data
   */
  updateSuperiorSourceSelected(state, data) {
    state.superiorSourceSelected = data;
  },

  /**
   * Cập nhật dữ liệu lỗi màn kiểm tra BCTC
   * @param {*} state
   * @param {*} data
   */
  updateFinancialGridData(state, data) {
    state.dataStepThree.financialGridData = data;
  },

  /**
   * Cập nhật dữ liệu lỗi màn kiểm tra BCQT
   * @param {*} state
   * @param {*} data
   */
  updateSettlementGridData(state, data) {
    state.dataStepThree.settlementGridData = data;
  },

  /**
   * Cập nhật dữ liệu checkbox: Số dự toán năm lấy theo thực tết phát sinh
   * @param {*} state 
   * @param {*} data 
   */
  updateIsCheckBoxRealityAriseForStepOne(state, data) {
    state.dataStepOne.isCheckBoxRealityAriseForStepOne = data;
  },

  /**
   * Cập nhật dữ liệu cho checkbox Số kinh phí sử dụng bao gồm số trích lập Cải cách tiên lương
   * 
   * @param {*} state 
   * @param {*} data 
   * DTQUOC 12.03.2024
   */
  updateIsFundIncludedSalaryReformAmount(state, data) {
    state.dataStepOne.isFundIncludedSalaryReformAmount = data;
  }
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
